
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import { useBookingStore } from "@/store/booking";
import { defineComponent, reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { watch } from "vue";

export default defineComponent({
	components: {
		BaseSection,
		BaseCheckbox,
	},
	setup() {
		const bookingStore = useBookingStore();
		const state = reactive({
			termsAccepted: bookingStore.getTerm("terms_and_conditions")?.checked ?? false,
		});

		const rules = {
			termsAccepted: {
				v: helpers.withMessage(
					() => "You need to accept the terms & conditions",
					() => state.termsAccepted
				),
			},
		};
		
		const terms = `I have read, understood and accepted all of the terms and conditions of passage.\nPlease tick the box to confirm acceptance of our terms and to continue.\n`;
		
		watch(state, () => {
			bookingStore.setTerm({
				identifier: "terms_and_conditions",
				checked: state.termsAccepted,
			});
		});

		const v$ = useVuelidate(rules, state);

		return { v$, terms };
	},
});
